module.exports = __webpack_public_path__ + "img/logo.1ab10d01.png";